import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=564947db&scoped=true"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&id=564947db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564947db",
  null
  
)

export default component.exports